export { default } from "./PlayerManagementEdit";
